import React, { useState } from 'react';
import { css } from '@emotion/react';

import { ButtonColorTokenProp } from '../../../theme/tokens/button-color';

import { hidden } from '../../../styles/a11y';

import { InputProps, NonContentfulWidgetProps } from '../shared';

import { Button, Input, Container } from './PhoneNumberWidget.styles';

export const DEFAULT_LABEL = 'Enter mobile phone number';
export const DEFAULT_PLACEHOLDER = 'Enter mobile number';
export const DEFAULT_BUTTON_TEXT = 'Get Started';

interface PhoneNumberWidgetProps extends NonContentfulWidgetProps {
  buttonContent?: JSX.Element | string;
  inputProps?: InputProps;
}

export function LegacyPhoneNumberWidget({
  id,
  className,
  buttonColor = 'dark',
  buttonHoverColor = 'light',
  cfButtonColor,
  cfButtonHoverColor,
  buttonContent = DEFAULT_BUTTON_TEXT,
  inputProps
}: PhoneNumberWidgetProps) {
  const [isLabelObscured, setIsLabelObscured] = useState(false);

  const defaultInputProps = {
    ctaText: buttonContent,
    onFocus: () => setIsLabelObscured(true),
    onBlur: () => setIsLabelObscured(false),
    ...inputProps
  };

  return (
    <div style={{ flex: 'auto' }}>
      <Container data-e2e="phone-container" className={className}>
        <label
          htmlFor={id}
          css={css`
            ${hidden}
          `}
        >
          {(!isLabelObscured && inputProps?.label) || ''}
        </label>
        <Input
          {...(defaultInputProps as InputProps)}
          data-e2e="phone-number"
          data-testid="phone-number-cta-v1"
        />
        <Button
          buttonColor={buttonColor as ButtonColorTokenProp}
          buttonHoverColor={buttonHoverColor as ButtonColorTokenProp}
          cfButtonColor={cfButtonColor}
          cfButtonHoverColor={cfButtonHoverColor}
          data-e2e="btn-getting-started"
          data-testid="btn-getting-started"
        >
          {buttonContent}
        </Button>
      </Container>
    </div>
  );
}
